<template>

  <div class="container-fluid">
    <h5>گزارش و نمودار پیشرفت کار کارگاه ها به تفکیک برنامه ریزی</h5>

    <div class="row my-2 text-center" v-if="nodata">
      <div class="col-12 mt-3">
        <h5>برنامه ای ثبت نشده است</h5>

      </div>
    </div>

    <div class="col-11">
      <div class="input-group">
        <div class="input-group-prepend custom">
          <div class="input-group-text">
            <span>کد برنامه را انتخاب کنید</span>
          </div>
        </div>
        <vs-select
          ref="selectedProgram"
          :isHeader="true"
          :data="programCodes"
          :selectedVal="programCodes.programId"
          :header="{label:'name'}"
          :mode="'edit'"
          @dataChanged="programSelect"
          aria-placeholder="لطفا برنامه را انتخاب کنید"
        ></vs-select>
        <!--v-bind:class="{ 'hover-pointer': mode!=='view' }"-->
      </div>
    </div>


    <hr/>
    <h5>گزارش پیشرفت برنامه</h5>

    <div class="col-12 mt-3">
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col" class="text-center">نام محصول</th>
          <th scope="col" class="text-center">کد برنامه</th>
          <!--<th scope="col" class="text-center">تاریخ برنامه</th>-->
          <th scope="col" class="text-center">تعداد</th>
          <th scope="col" class="text-center">تولیده شده</th>
          <th scope="col" class="text-center">انحراف</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="text-center">{{progress.productName}}</td>
          <td class="text-center">{{progress.programCode}}</td>
          <!--<td class="text-center">{{progress.programfDate}}</td>-->
          <td class="text-center">{{progress.totalCount}}</td>
          <td class="text-center">{{progress.completedCount}}</td>
          <td class="text-center">{{progress.remain < 0 ? "(" + progress.remain*-1 +"-)":progress.remain }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <b-tabs justified
            active-nav-item-class="font-weight-bold text-success"
            active-tab-class="font-weight-bold"
            content-class=""
            class="mt-3"
    >
      <!--------first tab------->
      <b-tab title="گزارش پیشرفت کار" active>
        <div class="row my-4">
          <div class="row my-2 text-center" v-if="progress.workReportProgramProgressLists == null">
            <div class="col-12 mt-3">
              <h5>برنامه دستور تولید داده نشده است</h5>

            </div>
          </div>
          <div class="col-12 mt-3" v-else>

            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col" class="text-center">تاریخ</th>
                <th scope="col" class="text-center">تعداد طبق برنامه</th>
                <th scope="col" class="text-center">تعداد تولید شده</th>


              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in progress.workReportProgramProgressLists">
                <!--<th scope="row" class="text-center">{{item.id}}</th>-->
                <td class="text-center">{{item.date}}</td>
                <td class="text-center">{{item.todayCount}}</td>
                <td class="text-center">{{item.todayDone}}</td>

              </tr>
              </tbody>
            </table>
          </div>


        </div>
      </b-tab>
      <!--------first tab------->
      <b-tab title="نمودار پیشرفت کار">
        <div class="row my-4">

          <div class="row my-2 text-center" v-if="progress.sendToWork === false">
            <div class="col-12 mt-3">
              <h5>برنامه دستور تولید داده نشده است</h5>
            </div>
          </div>
          <div class="col-12 mt-3" v-else>
            <div class="col-lg-12 col-sm-12 my-2">
              <div class="card shadow text-white  mb-1">
                <div class="card-body pb-0">
                  <div class="card-chart">
                    <canvas id="barchart1" width="1000" height="555"></canvas>
                  </div>
                </div>
              </div>
            </div>

            <!--<hr class="w-100 text-center"/>-->

            <!--<div class="col-lg-12 col-12 my-5">-->
              <!--<div class="card shadow text-white mb-1">-->
                <!--<div class="card-body pb-0">-->
                  <!--<div class="card-chart">-->
                    <!--<canvas id="area-chart" width="1600" height="400"></canvas>-->
                  <!--</div>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->

          </div>
        </div>

      </b-tab>
    </b-tabs>

    <!-------------------------------------------------------------------------------->

  </div>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import BaseService from "../../_framework/api/BaseService.js";
  import {mapState, mapMutations, mapActions} from "vuex";
  import Vue from "vue";
  import Products from "../Products.vue";
  import chart from "chart.js";
  import VsSelect from "../../_framework/VsSelect";
  import Moment from 'moment-jalali';

  export default {
    name: "workreport-program",
    created: () => {
    },
    components: {
      VsTable,
      Products,
      VsSelect,
      Moment,
    },
    data() {
      return {
        show: true,
        nodata: true,
        nodata2: true,
        access: {},
        product: {},
        productQuantity: {},
        productName: "",
        unitName: "",
        productId: "",
        rawproductQuantity: {},
        rawproducts: {},
        backgroundColor: ["#facf5a8f", "#ff59598f", "#49beb78f", "#a374d58f", "#5d99c68f", "#9cf1968f"],
        hoverBackgroundColor: ['#facf5ab5', '#ff5959b5', '#49beb7b5', '#a374d5b5', '#5d99c6b5', '#9cf196b5'],
        reportTotalProgram: [],

        programCodes: [],
        progress: {},
        proggressChart: {},
        areaChart: {},

      };
    },
    beforeMount() {
      // this.getAllRawProductsQuantity();
      // Chart.defaults.global.defaultFontFamily = 'shabnam';
      this.getProgram();
    },
    methods: {

      hideModal() {
        this.$refs.selectProductModal.hide();
      },
      getProgram() {
        new BaseService('Planning', '/GetAllProgramCode').getList().then((response) => {
          this.nodata = false;
          if (response.data === null || response.data === "") {
            this.nodata = true;
          } else {
            this.programCodes = response.data;
            if (this.programCodes.length > 0) {
              for (let i = 0; i < this.programCodes.length; i++) {
                this.programCodes[i].name = "برنامه کد " + this.programCodes[i].programCode + " کالای " + this.programCodes[i].productName + " تعداد " + this.programCodes[i].count + " باقیمانده " + (this.programCodes[i].count - this.programCodes[i].completed);
              }
            }
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      programSelect(prop, data) {
        // console.log(data);
        // console.log(data.programId);
        this.getReportProgram(data.programId, data.productId);

      },
      getReportProgram(id,productId) {
        new BaseService('WorksReports', '/GetWorkReportProgramProgress/' + id+'/'+productId).getList().then((response) => {
          // console.log(response.data);
          this.progress = response.data;
          this.progress.remain = this.progress.completedCount - this.progress.totalCount ;
          // this.progress.programfDate = Moment(this.progress.programDate.substring(0, 10), "YYYY-MM-DD").format("jYYYY/jMM/jDD");

          if (this.progress.workReportProgramProgressLists !== null && this.progress.workReportProgramProgressLists.length !== 0) {
            const dataName = [];
            const dataCount = [];
            const dataDone = [];
            let dCount = 0;
            let dDone = 0;

            for (let item of this.progress.workReportProgramProgressLists) {
              item.date = Moment(item.programDate.substring(0, 10), "YYYY-MM-DD").format("jYYYY/jMM/jDD")
              dataName.push(item.date);
              dCount += item.todayCount;
              dDone += item.todayDone;
              dataCount.push(dCount);
              dataDone.push(dDone);
            }

            let bar = "";
            if (dataName.length === 1) {
              bar = "bar";
            } else {
              bar = "line";
            }
            Chart.defaults.global.defaultFontFamily = 'shabnam';
            let polar = new Chart(document.getElementById("barchart1"), {

              type: bar,
              data: {
                labels: dataName,
                datasets: [
                  {
                    label: 'تعداد برنامه ریزی شده',
                    data: dataCount,
                    backgroundColor: 'rgba(255,193,7,0.71)',
                    borderColor: "rgba(255,143,0,0.71)"
                  },
                  {
                    label: 'تعداد انجام شده',
                    data: dataDone,
                    backgroundColor: 'rgba(249,60,103,0.71)',
                    borderColor: "rgba(198,40,40,0.71)"
                  },


                ]
              },
              options: {
                scales: {
                  // xAxes: [{
                  //   stacked: true
                  // }],
                  yAxes: [{
                    stacked: false,
                    ticks: {
                      beginAtZero: true,
                      min: 0,
                    }
                  }]
                },
                fill: {
                  type: 'gradient',
                  gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.9,
                    stops: [0, 90, 100]
                  }
                },
                title: {
                  display: true,
                  text: 'نمودار برنامه و گزارش کار'
                },
              }

            });


            this.areaChart = new Chart(document.getElementById("area-chart"), {
              type: 'line',
              data: {
                labels: dataName,
                datasets: [
                  {
                    label: 'تعداد برنامه ریزی شده',
                    data: dataCount,
                    backgroundColor: 'rgba(255,193,7,0.71)',
                    borderColor: "rgba(255,143,0,0.71)"
                  },
                  {
                    label: 'تعداد انجام شده',
                    data: dataDone,
                    backgroundColor: 'rgba(249,60,103,0.71)',
                    borderColor: "rgba(198,40,40,0.71)"
                  },

                ]
              },
              options: {
                scales: {
                  xAxes: [{
                    stacked: true
                  }],
                  yAxes: [{
                    stacked: true
                  }]
                },
                fill: {
                  type: 'gradient',
                  gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.9,
                    stops: [0, 90, 100]
                  }
                },
                title: {
                  display: true,
                  text: 'نمودار برنامه و گزارش کار'
                },
              }
            });

          }
        }).catch((error) => {
          console.log(error)
        });
      },


    },
    computed: {
      ...mapState(["vsTableFeed", "tableRowIndex"])
    }
  };
</script>
